/* Video en kaart als facade: er wordt niets van een derde partij geladen tot de
   bezoeker erom vraagt.

   Dit bestand registreert <hws-video>. Dat gebeurde eerder niet, waardoor de
   hele videosectie dood was: geen play, geen pauze, geen geluidsknop. De
   selectors volgen nu de markup van sections/video.liquid — data-video-frame,
   data-video-cover, data-video-toggle en data-video-sound. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_video']) return;
  window.__hwsLoaded['component_video'] = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class HwsVideo extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-video-frame]');
      this.cover = this.querySelector('[data-video-cover]');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.sound = this.querySelector('[data-video-sound]');
      this.provider = this.dataset.provider || 'native';
      this.autoplay = this.dataset.autoplay === 'true';
      this.embed = this.dataset.embed || '';
      this.playing = false;

      var self = this;
      if (this.cover) this.cover.addEventListener('click', function () { self.play(); });
      if (this.toggle) {
        this.toggle.addEventListener('click', function () {
          if (self.playing) { self.pause(); } else { self.play(); }
        });
      }
      if (this.sound) this.sound.addEventListener('click', function () { self.toggleSound(); });

      /* Autoplay alleen bij een eigen video, gedempt, en nooit met
         prefers-reduced-motion. */
      if (this.provider === 'native' && this.autoplay && !reduced) {
        var video = this.video();
        if (video) {
          video.muted = true;
          video.play().then(function () { self.setPlaying(true); }).catch(function () { /* geblokkeerd */ });
        }
      }
    }

    video() {
      return this.querySelector('video');
    }

    play() {
      if (this.provider === 'external') { this.loadEmbed(); return; }
      var video = this.video();
      if (!video) return;
      var self = this;
      video.play().then(function () { self.setPlaying(true); }).catch(function () { /* geblokkeerd */ });
      if (this.cover) this.cover.hidden = true;
    }

    pause() {
      var video = this.video();
      if (video) video.pause();
      this.setPlaying(false);
    }

    loadEmbed() {
      if (!this.embed || this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      var iframe = document.createElement('iframe');
      iframe.src = this.embed;
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('title', this.getAttribute('data-title') || 'Video');
      iframe.className = 'video__media';
      if (this.frame) {
        if (this.cover) this.cover.remove();
        this.frame.appendChild(iframe);
      }
      this.setPlaying(true);
    }

    setPlaying(state) {
      this.playing = state;
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', state ? 'true' : 'false');
      var playIcon = this.toggle.querySelector('[data-icon-play]');
      var pauseIcon = this.toggle.querySelector('[data-icon-pause]');
      if (playIcon) playIcon.hidden = state;
      if (pauseIcon) pauseIcon.hidden = !state;
      var label = state
        ? this.toggle.getAttribute('data-label-pause')
        : this.toggle.getAttribute('data-label-play');
      if (label) this.toggle.setAttribute('aria-label', label);
    }

    toggleSound() {
      var video = this.video();
      if (!video) return;
      video.muted = !video.muted;
      this.sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      var label = video.muted
        ? this.sound.getAttribute('data-label-on')
        : this.sound.getAttribute('data-label-off');
      if (label) this.sound.setAttribute('aria-label', label);
      var on = this.sound.querySelector('[data-icon-sound-on]');
      var off = this.sound.querySelector('[data-icon-sound-off]');
      if (on) on.hidden = video.muted;
      if (off) off.hidden = !video.muted;
    }
  }
  if (!customElements.get('hws-video')) customElements.define('hws-video', HwsVideo);

  /* Kaart-facade: Google Maps laadt pas na een klik. */
  document.addEventListener('click', function (event) {
    var mapButton = event.target.closest('[data-map-facade] button');
    if (!mapButton) return;
    var wrap = mapButton.closest('[data-map-facade]');
    var src = wrap && wrap.getAttribute('data-map-src');
    if (!src) return;
    event.preventDefault();
    var mapFrame = document.createElement('iframe');
    mapFrame.src = src;
    mapFrame.setAttribute('loading', 'lazy');
    mapFrame.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    mapFrame.setAttribute('title', mapButton.textContent.trim());
    wrap.innerHTML = '';
    wrap.appendChild(mapFrame);
  });
})();
